<!-- Affiliate Program页面 -->
<template>
    <div id="affiliateProgram" ref="affiliateProgram" element-loading-background="rgba(0, 0, 0, 0.05)" class="right-body" >
        <div class="ap-model">
          <div class="ap-body" :class="getH2Height()">
            <div class="ap-title">
              <div class="ap-title-text">
                <h1>
                  <div class="icon ap_orange_title"></div>
                  {{$t('language.affiliateProgram.title')}}
                </h1>
              </div>
              <p v-html="$t('language.affiliateProgram.headTips1')"></p>
              <p v-html="$t('language.affiliateProgram.headTips2')"></p>
              <p v-html="$t('language.affiliateProgram.headTips3')"></p>
              <div><button @click="openSignUp()"><span>{{$t('language.affiliateProgram.signUpBtn')}}</span></button></div>
              <p v-html="$t('language.affiliateProgram.tips')"></p>
            </div>
            <div class="ap-line"></div>
            <div class="ap-center">
              <h2>{{$t('language.affiliateProgram.howDoTipsTitle')}}</h2>
              <p v-html="$t('language.affiliateProgram.howDoTipsMsg')"></p>
            </div>
            <div class="ap-line"></div>
            <div class="ap-FAQ">
              <h2>{{$t('language.affiliateProgram.FAQsTitle')}}</h2>
              <div class="ap-FAQ-els" :style="getFAQHeight()">
                <el-scrollbar style='height:100%;' ref="scroll">
                  <div style='padding: 0px 12px 0 0;'>
                    <div class="ap-FAQ-body">
                      <div class="ap-FAQ-q" @click="chickFAQBtn(1)">
                        <span>{{$t('language.affiliateProgram.FAQ1')}}</span>
                        <div class="icon ap_faq_down" v-if="faqStatus!=1"></div>
                        <div class="icon ap_faq_up" v-if="faqStatus==1"></div>
                      </div>
                      <p class="ap-FAQ-a" v-if="faqStatus==1">{{$t('language.affiliateProgram.answer1')}}</p>
                    </div>
                    <div class="ap-FAQ-body">
                      <div class="ap-FAQ-q" @click="chickFAQBtn(2)">
                        <span>{{$t('language.affiliateProgram.FAQ2')}}</span>
                        <div class="icon ap_faq_down" v-if="faqStatus!=2"></div>
                        <div class="icon ap_faq_up" v-if="faqStatus==2"></div>
                      </div>
                      <p class="ap-FAQ-a" v-if="faqStatus==2">{{$t('language.affiliateProgram.answer2')}}</p>
                      <p class="ap-FAQ-ps" v-if="faqStatus==2">{{$t('language.affiliateProgram.answerPs2')}}</p>
                    </div>
                    <div class="ap-FAQ-body">
                      <div class="ap-FAQ-q"  @click="chickFAQBtn(3)">
                        <span>{{$t('language.affiliateProgram.FAQ3')}}</span>
                        <div class="icon ap_faq_down" v-if="faqStatus!=3"></div>
                        <div class="icon ap_faq_up" v-if="faqStatus==3"></div>
                      </div>
                      <p class="ap-FAQ-a" v-if="faqStatus==3">{{$t('language.affiliateProgram.answer3')}}</p>
                    </div>
                    <div class="ap-FAQ-body ap-FAQ-last">
                      <div class="ap-FAQ-q"  @click="chickFAQBtn(4)">
                        <span>{{$t('language.affiliateProgram.FAQ4')}}</span>
                        <div class="icon ap_faq_down" v-if="faqStatus!=4"></div>
                        <div class="icon ap_faq_up" v-if="faqStatus==4"></div>
                      </div>
                      <p class="ap-FAQ-a" v-if="faqStatus==4">{{$t('language.affiliateProgram.answer4')}}</p>
                      <p class="ap-FAQ-ps" v-if="faqStatus==4">{{$t('language.affiliateProgram.answerPs4')}}</p>
                    </div>
                  </div>
                </el-scrollbar>
              </div>
            </div>
            <div class="ap-center">
              <h2>{{$t('language.affiliateProgram.anyQuestionTitle')}}</h2>
              <p v-html="$t('language.affiliateProgram.anyQuestionTip')"></p>
            </div>
          </div>
        </div>
        <div class="task-buttom"></div>
    </div>
</template>
<script>
  import commonstate from '@/js/constant.js';
  import commonUtils from "@/js/workspace/common_util.js";

  export default {
    components: {
    },
    data: function () {
      return {
          user: commonstate.user,
          faqStatus: 0,//faq展开状态
      };
    },
    created() {
        
    },
    methods: {
      chickFAQBtn(status) {
          var height;
          if(this.faqStatus==status){
            this.faqStatus=0;
            height = 0;
          }else{
            this.faqStatus=status;
            height = (status-1)*48;
          }
          this.$nextTick(() => {
            this.$refs['scroll'].wrap.scrollTop = height;
          })
        },
        openSignUp() {
            let language = commonUtils.getLocaleToIndex(localStorage.getItem("locale"));
            if(language=="en"){
              language = "en_us";
            }
            if(language=="cn"){
              language = "zh_cn";
            }
            if(language=="tw"){
              language = "zh_hk";
            }
            window.open("https://signup.partnerize.com/signup/"+language+"/cleverbridge");
        },
        getFAQHeight() {
            let language = commonUtils.getLocaleToIndex(localStorage.getItem("locale"));
            // if(language=="it"){
            //   return "height:235px;";
            // }
            return "";
        },
        getH2Height() {
            let language = commonUtils.getLocaleToIndex(localStorage.getItem("locale"));
            if(language=="it"||language=="fr"||language=="es"||language=="de"||language=="jp"||language=="it"){
              return "min-h2";
            }
            return "";
        },
    }
  }
</script>
<style>
#affiliateProgram .task-buttom{
  bottom: 0;
  position: absolute;
  width: 100%;
}

.ap-model {
  top: 2%;
  height: 96%;
  margin: 0 25%;
  z-index: 1000;
  background: #ffffff;
  position: relative;
  border: 1px solid #D1E0F5;/*no*/
}

.ap-body {
  margin: 0 11%;
}

.ap-body p {
  margin: 0.67em 0;/*no*/
  color: #828282;
}

.ap-body p span {
  font-weight: bold;
  color: #000;
}

.ap-body a {
  text-decoration: none;
}

.ap-line {
  height: 1px;/*no*/
  margin: 0.2rem 0 0.2rem 0;
  background: #EBEDEF;
}

.ap-title {
  text-align: center;
}

.ap-title-text {
  margin: 0;
}

.ap-title-text h1{
  display: inline-block;
  margin: 1em 0 0 0;
  line-height: 50px;/*no*/
}

.ap-title-text .ap_orange_title{
  margin-right: 0.5em;
  float: left;
}

.ap-title button{
  margin-top: 1em;/*no*/
  height: 3em;
}

.ap-title button span{
  margin: 0 1em;/*no*/
}

.ap-center {
  height: 19%;
}

.ap-center p {
  color: #000;
}

.ap-FAQ {
  height: 40%;
}

.ap-FAQ-body {
  border: 1px solid #C3C6CC;/*no*/
  padding: 0 16px;/*no*/
  margin-bottom: 1em;
}

.ap-FAQ-last {
  margin-bottom: 0;
}

.ap-FAQ-q {
  margin: 0.4em 0;
  color: #000;
  cursor: pointer;
}

.ap-FAQ-q .icon{
  float: right;
}

.ap-FAQ-ps {
  font-size: 14px;/*no*/
}

.ap-FAQ-els {
  height: 195px;/*no*/
}

#affiliateProgram::-webkit-scrollbar{
    width: 8px;/*no*/
    height: 10Px;/*no*/
    /* 给滚动条一个最小的高度 */
    background-color: #fff;
}

#affiliateProgram .el-scrollbar__wrap{
    margin-bottom: 0;
}

#affiliateProgram .el-scrollbar__bar {
    right: 0;
    top: 0;
}

#affiliateProgram::-webkit-scrollbar-thumb{
    min-height: 40px;
    /*no*/
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}

.min-h2 h2 {
  margin: 0.5em 0;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/affiliateProgram.vue